import { profiles } from '../services/ProfileService'
import { useQuery } from '@tanstack/react-query'

export const useTalentProfile = (profileId?: string) => {
  return useQuery({
    enabled: !!profileId,
    queryKey: ['talent-profile', profileId],
    refetchOnWindowFocus: false,
    queryFn: () => {
      profiles.init(profileId!)
      return profiles.getProfile()
        .catch(e => {
          console.error(e)
        })
    }
  })
}
